// Newsletter CTA should be displayed on the homepage, only the first time the user visits the site and he did not interact with the CTA.
// A.k.a. if the user closes or submits the CTA, it should not be displayed again.
// The CTA should appear after 5 seconds of the user being on the page.
const newsletterCtaSelector = ".newsletter-cta";
const newsletterCtaCloseSelector = ".newsletter-cta__close";
const newsletterCtaFormSelector = ".newsletter-cta__form";
const newsletterVisibleClass = "newsletter-cta--visible";

const timeToWaitBeforeShowingNewsletterCta = 5000;
const storageKey = "newsletterCtaInteracted";

export const autofillEmail = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  const emailInput = document.querySelector<HTMLInputElement>(
    "[data-email-autofill]",
  );
  if (emailInput) {
    emailInput.value = email || "";
  }
};

export const manageNewsletterCta = () => {
  const newsletterCta = document.querySelector(newsletterCtaSelector);
  if (!newsletterCta) {
    return;
  }

  const newsletterCtaClose = document.querySelector(newsletterCtaCloseSelector);
  const newsletterCtaForm = document.querySelector(newsletterCtaFormSelector);
  const hasTheUserInteracted = localStorage.getItem(storageKey);
  if (hasTheUserInteracted) {
    return;
  }

  newsletterCtaClose?.addEventListener("click", () => {
    newsletterCta.classList.remove(newsletterVisibleClass);
    localStorage.setItem(storageKey, "true");
  });

  newsletterCtaForm?.addEventListener("submit", () => {
    newsletterCta.classList.remove(newsletterVisibleClass);
    localStorage.setItem(storageKey, "true");
  });

  setTimeout(() => {
    newsletterCta.classList.add(newsletterVisibleClass);
  }, timeToWaitBeforeShowingNewsletterCta);
};
